export function handleImgError(e) {
    e.target.onerror = null; // Prevent infinite loop if fallback also fails
    e.target.src = `/Images/Content/mh-registered-white.png`; // Path to your fallback image in public/
}